import { FEATURE_PARAM } from "./medFeatureParams";
import { removeURLParam } from "./urlParams";
import { isNovoBuyflowEnabled } from "./userSegment/features";
import { trackEvent } from "./api/tracker";

/**
 * Legacy `feature=` values that are deprecated in the membership buyflow. Users in
 * the membership soft launch who arrive with one of these are sent through the
 * default membership flow instead.
 */
export const LEGACY_FEATURE_PARAMS: readonly string[] = [
  FEATURE_PARAM.TIRZEPATIDE,
  FEATURE_PARAM.MICRODOSE,
  FEATURE_PARAM.MICRODOSE_TIRZEPATIDE,
  FEATURE_PARAM.ORALS,
  FEATURE_PARAM.BRANDED,
];

let droppedLegacyFeatureParam: string | undefined;

/**
 * Removes a legacy `feature=` param from the URL when the membership buyflow is
 * enabled, so every downstream `feature` check (and forwarded params on
 * reroll) falls back to the default membership flow.
 *
 * Must run before the server context request and before pixels load.
 */
export function dropLegacyFeatureParamForMembership() {
  droppedLegacyFeatureParam = undefined;

  if (!isNovoBuyflowEnabled()) {
    return;
  }

  const feature = new URLSearchParams(window.location.search).get("feature");
  if (!LEGACY_FEATURE_PARAMS.includes(feature)) {
    return;
  }

  removeURLParam("feature");
  droppedLegacyFeatureParam = feature;
}

/**
 * Tracks the param dropped by `dropLegacyFeatureParamForMembership` so remaining
 * links using legacy params can be tracked down. Call once mixpanel is set up.
 */
export function trackDroppedLegacyFeatureParam() {
  if (!droppedLegacyFeatureParam) {
    return;
  }

  trackEvent("LegacyFeatureParamDropped", {
    feature: droppedLegacyFeatureParam,
  });
}
